export const InputTypes = {
  DATE_PICKER: "date_picker",
  NUMBER: "number",
  RADIO: "radio",
  SELECT: "select",
  TEXT: "text",
};
